export const pickTypes = {
  single: 'single',
  range: 'range',
};

export const displayModes = {
  scroll: 'scroll',
  flat: 'flat',
};

export const rangeLockKeys = {
  start: 'start',
  end: 'end',
};
